export default "__VITE_ASSET__DulaHIVw__"